export const FETCH_CHECK_PASSWORD = 'FETCH_CHECK_PASSWORD'
export const FETCH_CHECK_PASSWORD_SUCCESS = `${FETCH_CHECK_PASSWORD}_SUCCESS`
export const FETCH_CHECK_PASSWORD_FAIL = `${FETCH_CHECK_PASSWORD}_FAIL`

export const FETCH_CHANGE_URA_PASS = 'FETCH_CHANGE_URA_PASS'
export const FETCH_CHANGE_URA_PASS_SUCCESS = `${FETCH_CHANGE_URA_PASS}_SUCCESS`
export const FETCH_CHANGE_URA_PASS_FAIL = `${FETCH_CHANGE_URA_PASS}_FAIL`

export const fetchCheckPassword = data => ({
  type: FETCH_CHECK_PASSWORD,
  payload: {
    client: 'onboardingApi',
    request: {
      method: 'post',
      headers: {
        'content-type': 'application/json'
      },
      url: `v1/api/Participant/passwordLegacy/validate`,
      data: JSON.stringify(data)
    }
  }
})

export const fetchChangeUraPass = data => ({
  type: FETCH_CHANGE_URA_PASS,
  payload: {
    client: 'onboardingApi',
    request: {
      method: 'post',
      headers: {
        'content-type': 'application/json'
      },
      url: `/v1/api/Ura/password/change`,
      data: JSON.stringify(data)
    }
  }
})

const INITIAL_STATE = {
  isLoading: false,
  dataResponse: null,
  errors: null
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_CHECK_PASSWORD:
      return { ...state, isLoading: true, errors: null, dataResponse: null }
    case FETCH_CHECK_PASSWORD_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case FETCH_CHECK_PASSWORD_FAIL:
      return {
        ...state,
        isLoading: false
      }
    case FETCH_CHANGE_URA_PASS:
      return { ...state, isLoading: true, errors: null, dataResponse: null }
    case FETCH_CHANGE_URA_PASS_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case FETCH_CHANGE_URA_PASS_FAIL:
      return {
        ...state,
        isLoading: false
      }
    default:
      return { ...state }
  }
}



// WEBPACK FOOTER //
// ./src/Participant/UraPassword/ChangeUraPassword/ducks.js